export default __webpack_public_path__ + "static/media/checkSmall.7ba5f9ce.svg";